import React from "react";
import { useBoxBreakCountUnexpectedSkuUnits } from "../../cards/BoxBreakCountUnexpectedSkuUnitsCard";
import { DoneButton } from "@deliverr/ui-facility";

interface Props {
  disabled?: boolean;
}

export const BoxBreakUnitCountCompleteButton: React.FC<Props> = ({ disabled }) => {
  const { onUnitCountSubmit } = useBoxBreakCountUnexpectedSkuUnits();
  return <DoneButton onClick={onUnitCountSubmit} disabled={disabled} block />;
};
